import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import features from 'app/common/containers/features';
import { reduxForm, Field } from 'redux-form';
import { components, contentfulModels } from '@glowforge/ui-common';


import SubmitActions from 'app/common/components/forms/submit-actions';
import { getInvalidEmails } from 'app/util';

import './machine-name.less';

const { pageStringsPropType } = contentfulModels;
const { Text } = components;

export const formValidation = (values) => {
  const errors = {};
  if (values.email) {
    const invalidEmails = getInvalidEmails(values.email);
    if (invalidEmails.length > 1) {
      errors.email = `${invalidEmails.join(', ')} are not valid emails.`;
    } else if (invalidEmails.length === 1) {
      errors.email = `${invalidEmails[0]} is not a valid email.`;
    }
  }

  if (!values.name || values.name.trim().length === 0) {
    errors.name = 'Required';
  }
  if (values.name.length > 15) {
    errors.name = 'Machine name must be 15 characters or less.';
  }

  return errors;
};

const MachineName = (props) => {
  let emailFormExplanation = '';
  if (props.features.USER_ROLE_MANAGEMENT) {
    emailFormExplanation = (
      <div className='row compact'>
        <p>{props.pageStrings['onboarding-email-form-explanation']}</p>
      </div>);
  }

  return (
    <form className='MachineName contentPage' onSubmit={props.handleSubmit}>
      <Helmet title={`Glowforge Setup - ${props.title}`} />
      <div className='content'>
        <h1 className='h2'>{props.title}</h1>
        <div className='row'>
          <Field
            className='name'
            name='name'
            label={props.pageStrings['onboarding-gf-name-label']}
            placeholder={props.pageStrings['onboarding-name-placeholder']}
            component={Text} />
          <p>{props.pageStrings['onboarding-gf-name-description']}</p>
        </div>
        <h4 className='h4'>{props.pageStrings['onboarding-invite-user-header']}</h4>
        <div className='row compact'>
          <Field
            className='email'
            name='email'
            label='&nbsp;'
            placeholder={props.pageStrings['onboarding-email-form-placeholder']}
            component={Text} />
          <p>{props.pageStrings['onboarding-email-form-description']}</p>
        </div>
        {emailFormExplanation}
        <SubmitActions
          {...props}
          successMessage={props.pageStrings['onboarding-sucess-message']}
          inProgressMessage={props.pageStrings['onboarding-naming-pending-submit-message']}
          submitClass={`${props.isOrangeMode ? 'orange' : 'brand'} large clearButton`} />
      </div>
    </form>
  );
};

MachineName.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  pageStrings: pageStringsPropType.isRequired,
  features: PropTypes.object, // eslint-disable-line
  isOrangeMode: PropTypes.bool,
};

MachineName.defaultProps = {
  title: '',
  namePlaceHolder: '',
  emailPlaceHolder: '',
  nameLabel: '',
  nameDescription: '',
  emailDescription: '',
  inviteHeader: '',
  isOrangeMode: false,
};

const MachineNameForm = reduxForm({
  form: 'machineNameForm',
  validate: formValidation,
})(features(MachineName));

export default MachineNameForm;



// WEBPACK FOOTER //
// ./app/components/setup/machine-name.jsx